import {
  PASSWORD_MAX_LENGTH,
  PASSWORD_MIN_LENGTH,
  hasSequentialDigits,
  passwordContainsUserFirstName,
} from 'app/components/Password/passwordValidation';

export type PasswordCriterion = {
  id: string;
  label: string;
  test: (password: string) => boolean;
};

export function getPasswordCriteriaRules(userName?: string): PasswordCriterion[] {
  return [
    {
      id: 'min-length',
      label: `Pelo menos ${PASSWORD_MIN_LENGTH} caracteres`,
      test: (password) => password.length >= PASSWORD_MIN_LENGTH,
    },
    {
      id: 'uppercase',
      label: 'Uma letra maiúscula',
      test: (password) => /[A-Z]/.test(password),
    },
    {
      id: 'lowercase',
      label: 'Uma letra minúscula',
      test: (password) => /[a-z]/.test(password),
    },
    {
      id: 'special-char',
      label: 'Um caractere especial',
      test: (password) => /[\W_]/.test(password),
    },
    {
      id: 'no-sequential-numbers',
      label: 'Não conter números sequenciais',
      test: (password) => !hasSequentialDigits(password),
    },
    {
      id: 'number',
      label: 'Um número',
      test: (password) => /[0-9]/.test(password),
    },
    {
      id: 'max-length',
      label: `No máximo ${PASSWORD_MAX_LENGTH} caracteres`,
      test: (password) => password.length <= PASSWORD_MAX_LENGTH,
    },
    {
      id: 'no-username',
      label: 'Não conter o nome do usuário',
      test: (password) => !passwordContainsUserFirstName(password, userName),
    },
  ];
}
